module.exports = __webpack_public_path__ + "img/doc1.3aafd2a1.png";